<template>
  <div class="emf-internal-res-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E = U + Ir | I = E / (R + r)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：路端电压随电流变化 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- U-I 图线 -->
            <line x1="50" y1="180" x2="350" y2="180" stroke="#888" />
            <line x1="50" y1="180" x2="50" y2="30" stroke="#888" />
            <text x="360" y="185" fill="#888" font-size="9">I</text>
            <text x="45" y="25" fill="#888" font-size="9">U</text>

            <path :d="uiChartPath" fill="none" stroke="#ff4757" stroke-width="2" />
            
            <!-- 当前工作点 -->
            <circle :cx="50 + currentI * 30" :cy="180 - currentU * 10" r="4" fill="#ffd700" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>电动势 E</label>
               <span class="val">{{ E.toFixed(1) }} V</span>
            </div>
            <div class="stat">
               <label>内阻 r</label>
               <span class="val">{{ r.toFixed(1) }} Ω</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>外电阻 R</label>
                  <el-slider v-model="externalR" :min="0.1" :max="50" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>设置内阻 r</label>
                  <el-slider v-model="r" :min="0.5" :max="5" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="law-box" v-latex>
            <p><strong>闭合电路欧姆定律：</strong>电源内部也存在电阻。当外电路负载增大（$R$ 减小）时，电流 $I$ 增大，内阻分压 $Ir$ 增大，导致<strong v-latex>路端电压 $U$</strong> 下降。这就是电源的“软特性”。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EMFInternalResViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      E: 12,
      r: 2,
      externalR: 10
    }
  },
  computed: {
    currentI() {
       return this.E / (this.externalR + this.r);
    },
    currentU() {
       return this.currentI * this.externalR;
    },
    uiChartPath() {
       let d = `M 50 ${180 - this.E * 10}`;
       // Line: U = E - Ir
       const maxI = this.E / this.r;
       d += ` L ${50 + maxI * 30} 180`;
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
.emf-internal-res-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ff4757; background: rgba(255,71,87,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; display: flex; gap: 20px;
      .stat { background: rgba(0,0,0,0.5); padding: 5px 12px; border-radius: 6px; border-left: 3px solid #ff4757; label { display: block; font-size: 0.55rem; color: #888; } span { font-size: 0.9rem; color: #fff; font-family: monospace; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.law-box { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
